import { Modal } from "antd";
import {
  getProfileIdentity,
  isSelectableProfile,
  isDefaultProfile,
} from "@/utils/profileUtils";
import "./index.less";

/**
 * 功能入口前确认档案弹窗
 *
 * Props:
 * - open: boolean, 控制弹窗显示
 * - profiles: array, 可选档案列表
 * - selectedKey: string, 当前选中档案的 key
 * - onSelectKey: (key) => void, 选中档案的回调
 * - onOk: () => void, 点击确认进入回调
 * - onCancel: () => void, 点击取消回调
 * - title: string, 弹窗标题（可选）
 * - okText: string, 确认按钮文案（可选）
 * - hintText: string, 提示文案（可选）
 */
export default function FeatureProfileModal({
  open,
  profiles = [],
  selectedKey = "",
  onSelectKey,
  onOk,
  onCancel,
  title = "请选择关联人信息",
  okText = "确认进入",
  hintText = "已为您优先选中默认儿童，请确认本次使用的档案。",
}) {
  return (
    <Modal
      title={title}
      open={open}
      okText={okText}
      cancelText="取消"
      centered
      className="feature-profile-confirm-modal"
      onOk={onOk}
      onCancel={onCancel}
      okButtonProps={{
        disabled: !selectedKey,
        style: { backgroundColor: "#5B69FC", borderColor: "#5B69FC" },
      }}
    >
      <div className="feature-profile-hint">{hintText}</div>
      <div className="feature-profile-list">
        {profiles.map((profile) => {
          const profileKey = getProfileIdentity(profile);
          const selected = profileKey === selectedKey;
          const disabled = !isSelectableProfile(profile);
          return (
            <button
              type="button"
              key={profileKey}
              disabled={disabled}
              className={`feature-profile-card ${selected ? "active" : ""} ${disabled ? "disabled" : ""}`}
              onClick={() => onSelectKey?.(profileKey)}
            >
              <span className="feature-profile-main">
                <strong>{profile.profileNick || "未命名儿童"}</strong>
                <small>
                  {profile.profileSex === "1" ? "男" : "女"}
                  {profile.profileAge ? ` · ${profile.profileAge}` : ""}
                </small>
              </span>
              <span className="feature-profile-status">
                {disabled
                  ? "不可用"
                  : selected
                    ? "已选择"
                    : isDefaultProfile(profile)
                      ? "默认"
                      : "选择"}
              </span>
            </button>
          );
        })}
      </div>
    </Modal>
  );
}
